export default "__VITE_ASSET__28eab47e__"